module.exports = __webpack_public_path__ + "img/copy-serum-icon.d0824cc6.svg";